import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Route, withRouter, Link, Switch } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import queryString from 'query-string';
import condition from 'ol/events/condition';

import InfoWindow from '../devices/InfoWindow';
import MainNavigation from '../layout/MainNavigation';
import DateSelect from '../layout/DateSelect';
import SideBar from '../layout/SideBar';
import EventForm from '../forms/Event';
import { Icon } from '../icons';
import Loading from '../layout/Loading';
import Content from '../layout/Content';
import Button from '../layout/Button';
import CreateNewEventButton from '../layout/CreateNewEventButton';
import SideBarNavigationLink from '../layout/SideBarNavigationLink';
import NewProfile from '../layout/NewProfile';
import ProfileList from '../profiles/List';
import ProfileShow from '../profiles/Show';
import ProfileNew from '../profiles/New';
import ProfileEdit from '../profiles/Edit';

import {
  toggleCalendar,
  setSelectedDate
} from '../../actions/dateSelector';

import { setHoveredDevices } from '../../actions/map';
import {
  clusterStyles,
  defaultProfileStyles,
  activeProfileStyles,
  warningProfileStyles } from '../../mapStyles';

  const DEFAULT_CENTER = [36.45923015624996, 43.413130671534105];
  const DEFAULT_ZOOM = 3;

  import { getFeaturesByProfile, toFeature } from '../../reducers/devices';

  import {
    TileLayer,
    BingSource,
    VectorLayer,
    VectorSource,
    ClusterSource,
    OverLay,
  } from '../ol';

  import MapWithRouter from '../containers/MapWithRouter';

  import styles from './profiles.scss';

  class Profiles extends Component {

    constructor(props) {
      super(props);

      this.state = {
        featuresByProfile: {},
        allFeatures: [],
        hoveredDevice: null,
        shouldZoomToFit: props.location.search ? false : true,
      }

      this.featureMouseOn = this.featureMouseOn.bind(this);
      this.featureMouseOff = this.featureMouseOff.bind(this);
      this.onClustersReady = this.onClustersReady.bind(this);
    }

    componentDidMount() {
      const { devices, profiles } = this.props;
      this.setState({
        featuresByProfile: getFeaturesByProfile(devices),
        allFeatures: devices.map(toFeature),
      })
    }

    componentDidUpdate(prevProps) {
      if((prevProps.profiles !== this.props.profiles) || prevProps.devices !== this.props.devices ) {
        this.setState({
          featuresByProfile: getFeaturesByProfile(this.props.devices),
          allFeatures: this.props.devices.map(toFeature)
        });
      }
    }

    onClustersReady(vectorSource) {
      if (this.state.shouldZoomToFit) {
        const extent = vectorSource.getExtent();
        if(extent[0] !== Infinity) {
          this.refs.map_component.zoomToExtent(extent);
        }
      }
    }

    featureMouseOn(e) {
      const { devices, profiles } = this.props;
      this.setState({
        hoveredDevice: devices.find(d => d.id === e.element.get("id")),
        hoveredProfile: profiles.find(p => p.id === e.element.get("profile_id")),
        hoverLocation: e.element.getGeometry().getCoordinates()
      })
    }

    featureMouseOff(e) {
      this.setState({
        hoveredDevice: null,
        hoveredProfile: null,
        hoverLocation: null,
      })
    }

    render() {
      const {
        match,
        location,
        history,
        activeProfileId,
        loadingDevices,
        loadingProfiles,
        profiles,
        events,
        organisationId,
        selectedDate,
        onDateChange,
        onFeatureHover,
        toggleDateSelector,
        showDateSelect,
        hoveredDevices,
      } = this.props;

      const {
        featuresByProfile,
        allFeatures,
      } = this.state;

      // Should this be here??
      const { zoom } = queryString.parse(location.search)

      return (
        <div>

          <div className="grid">
            <SideBar>
              <NewProfile organisationId={organisationId} />
              <ProfileList profiles={profiles} activeProfileId={activeProfileId} loading={loadingProfiles} />
            </SideBar>
            <Content>
              <MapWithRouter ref="map_component" onFeatureHover={onFeatureHover} location={location} history={history}>
                <TileLayer opacity={1}>
                  <BingSource
                    apiKey="AkPQjO5c6rlGFZF_PBGt77p7flbuLqSfvOcpwdaaMPIoOVZuiPN_PuR3omBFeICO"
                    imagerySet="CanvasGray"
                    maxZoom={19} />
                </TileLayer>
                {profiles.map(profile =>
                  <VectorLayer visible={zoom > 13} zIndex={activeProfileId === profile.id ? 1 : 0} key={profile.id} style={activeProfileId === profile.id ? activeProfileStyles : defaultProfileStyles}>
                    <VectorSource features={featuresByProfile[profile.id]} />
                  </VectorLayer>
                )}
                <VectorLayer visible={zoom > 13 && featuresByProfile[null]} zIndex={2} style={warningProfileStyles}>
                  <VectorSource features={featuresByProfile[null]} />
                </VectorLayer>
                {allFeatures.length > 0 &&
                  <VectorLayer style={clusterStyles} visible={zoom <= 13}>
                    <ClusterSource features={allFeatures} onReady={this.onClustersReady} />
                  </VectorLayer>
                }
                <InfoWindow />
              </MapWithRouter>
            </Content>

            <TransitionGroup>
              <CSSTransition key={location.pathname} timeout={800} classNames={isNewOrEdit(location.pathname) ? 'fade' : 'slide-right'}>
                <div>
                  <Switch location={this.props.location}>
                    <Route exact path="/organisations/:organisationId/profiles/new" component={ProfileNew} />
                    <Route exact path="/organisations/:organisationId/profiles/:profileId" component={ProfileShow} />
                    <Route exact path="/organisations/:organisationId/profiles/:profileId/edit" component={ProfileEdit} />
                  </Switch>
                </div>
              </CSSTransition>
            </TransitionGroup>
          </div>

          <MainNavigation>
            {/*<DateSelect />
            <CreateNewEventButton />*/}
          </MainNavigation>
        </div>
      );
    }
  }

  function isNewOrEdit(pathname) {
    const last_element = pathname.split('/').slice(-1)
    return last_element == 'new' || last_element == 'edit';
  }

  export default withRouter(connect(
    ({ devices, profiles, events, ui, router }, { match }) => ({
      profiles: profiles.data,
      devices: devices.data,
      loadingDevices: devices.fetching,
      loadingProfiles: profiles.fetching,
      activeProfileId: match.params.profileId,
      organisationId: match.params.organisationId,
      events: events.data,
      //hoveredDevices: ui.map.hoveredDeviceIds,
    }), {
      onFeatureHover: setHoveredDevices
    }
  )(Profiles));



// WEBPACK FOOTER //
// ./src/components/pages/Profiles.js